import React, { useEffect, useRef } from 'react'

import { useApp } from '@/core/contexts/app'
import { path } from '@/core/utils'

import ScrollDown from '../scroll-down/ScrollDown'
import Image from '@/components/base/image/Image'

import { BannerProps } from './type'
import { classnames } from 'begonya/functions'

const Banner: React.FunctionComponent<BannerProps> = ({
  title,
  subTitle,
  image,
  background,
  isStatic,
}) => {
  const app = useApp()
  const imageRef = useRef<HTMLInputElement>(null)
  const titleRef = useRef<HTMLInputElement>(null)

  const backgroundURL = path.asset(
    app.environment,
    background && background.src
  )

  useEffect(() => {
    const handleScroll = () => {
      const value = window.scrollY
      if (imageRef.current) {
        imageRef.current.style.bottom = `-${value / 2}px`
      }
      if (titleRef.current) {
        titleRef.current.style.top = `${150 + value / 1}px`
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <div
      className={classnames('banner', isStatic && 'banner--static')}
      style={{ background: `url('${backgroundURL}')` }}
    >
      <div className="parallax">
        <h1 ref={titleRef} className="title">
          {title}
          {subTitle && <span>{subTitle}</span>}
        </h1>
        {!isStatic && (
          <div ref={imageRef} className="parallax-layer">
            <Image {...image} alt="" />
          </div>
        )}
      </div>
      <ScrollDown />
    </div>
  )
}

export default Banner
